import { access } from '@driftt/traffic-control'

export const {
  hasScopes, hasAnyScope, hasGates, hasAnyRole, hasAllGates, hasAccess, isAdmin, isAgent, isUser, checkGate, hasAnyFeature, hasFeatures
} = access

const isPlaybooksUser = () => hasAnyRole("Playbooks")
const isReportsUser = () => hasAnyRole("Reporting")
const rbacUserCanEditPlaybooks = () => hasAnyFeature([
  {
    featureName: 'email_playbooks',
    accessLevel: 'WRITE'
  },
  {
    featureName: 'signature_playbooks',
    accessLevel: 'WRITE'
  }
])

const rbacUserCanViewPlaybookReports = () => hasAnyFeature([
  {
    featureName: 'email_playbook_reports',
    accessLevel: 'READ'
  }
])

const rbacUserCanViewContactsPage = () => hasFeatures({
  featureName: 'contacts',
  accessLevel: 'READ'
})

export const userCanEditPlaybooks = () => isAdmin() || isPlaybooksUser() || rbacUserCanEditPlaybooks()
export const userCanAccessOrgPlaybookReports = () => isAdmin() || isReportsUser() || isPlaybooksUser() || rbacUserCanViewPlaybookReports()
export const userHasContactsPageAccess = () => isAdmin() || rbacUserCanViewContactsPage()
